import SpecializationProfile from './specialization-profile';

export default SpecializationProfile;
